import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../base";

function FormCheckboxPreview({ ...props }) {
  return <BasePreview {...props}>
    <input type="checkbox" />
  </BasePreview>
}

export default define('form-checkbox', FormCheckboxPreview, Fragment)
  .shared(prop.share('FormCheckbox', 'form-checkbox'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .build()

